import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import { en } from 'localization';
import {
  getAuthToken,
  getRefreshToken,
  removeAuthToken,
  updateAuthToken,
} from 'utils/token-handler';
import { showErrorToast } from 'utils/error-response-handler';
import { useRefreshToken } from './authentication-api/authentication-requests';
import { PUBLIC_ROUTES } from 'routes/constants';
import { ErrorResponse } from 'types/error';

const {
  errorMessages: { GenericError },
} = en;

export let axiosParams = {
  baseURL: process.env.REACT_APP_BASEURL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
};

let instance = axios.create(axiosParams);

instance.interceptors.request.use(
  config => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error?.response.status === 401) {
      if (window.location.pathname === '/login') {
        showErrorToast(error?.response?.data as ErrorResponse);
        return;
      } else if (PUBLIC_ROUTES.includes(window.location.pathname)) {
        showErrorToast(error?.response?.data as ErrorResponse);
        setTimeout(() => {
          location.replace('/login');
        }, 3000);
      } else {
        const refToken = getRefreshToken();

        if (refToken) {
          const { mutate } = useRefreshToken();

          mutate(refToken, {
            onSuccess: res => {
              updateAuthToken(res?.accessToken);
              location.replace(location.href);
            },
          });
        } else {
          removeAuthToken();

          window.location.href = '/login';
        }
      }
    } else if (
      error?.response.status >= 500 &&
      window.location.pathname.includes('/dashboard')
    ) {
      window.location.href = '/dashboard/error';
    } else if (error?.response.status >= 500) {
      window.location.href = '/error';
    } else if (error) {
      showErrorToast(error?.response?.data as ErrorResponse);
    } else toast.error(GenericError.default);

    return Promise.reject(error);
  }
);

export default instance;
